import React, { useContext, useEffect, useState } from 'react';
import { getGrades } from "./data";
import * as S from "./style";
import * as SS from '../../common/styled-components/styled-components';
import Image from '../../../../app/js/components/loggedout/common/Image';
import i18n from '../../../../app/js/utils/i18n';
import { SemContext } from "../../context/SemContext";
import { setCoachmarkFlag } from '../../../../app/js/utils/web-helper';

const GradeSelectionModal = ({ onCloseHandler }) => {
  const { state } = useContext(SemContext);
  const campaign_code = localStorage.getItem("campaign_code");
  const variant = localStorage.getItem("sem_variant") || state.variant;
  const [grades, setGrades] = useState([]);
  const hideFooter = state.settings && state.settings.hide_grade_modal_footer === "true";
  const isUkorAu = i18n.language == "en-AU" || i18n.language == "en-GB";
  const campaign_codes = ["redemption", "splashlearn_giftup"];

  const settingUpAvailableGrades = () => {
    if (state.settings.show_promo_popup === 'true' && !campaign_codes.includes(campaign_code)) {
      const availableProducts = state.products[0] && state.products[0].properties && state.products[0].properties.display_name !== 'Math' ? `pk,k,1,2` : `pk,k,1,2,3,4,5`;
      setGrades(getGrades(availableProducts))
    } else {
      setGrades(getGrades(state.settings && state.settings.grades));
    }
  }

  useEffect(()=> {
    setCoachmarkFlag(); 
    settingUpAvailableGrades();
    const landingPageUrl = localStorage.getItem("landing_page_url");
      trackAnalyticsEvent("Grade Popup Viewed", { 'landingpage_details': landingPageUrl})
  },[])

  const onClickHandler = (e, grade) => {
    trackAnalyticsEvent('Grade Selected on Popup', {
      'Grade': grade,
      'Landing Page' : variant,
      ...(campaign_code && campaign_code != "undefined" && {campaign_code})
    }, true)
    trackAnalyticsEvent("Interacted Plan Purchase Combined Page", { 'Interaction Details': `Changed Grade` });
    onCloseHandler(grade);
  }

  return (
    <SS.ModalOverlay>
      <SS.Modal>
        <SS.ModalTitle>What {i18n.t('grade')} is your child in?</SS.ModalTitle>
        <SS.ModalBody>
          <S.GradeBox>
            {
              grades && grades.map((item, idx) => {
                return (
                  <S.GradeItem key={idx} isUkorAu={isUkorAu} onClick={(e) => onClickHandler(e, item.value)} image={item.image} rotate={item.rotate} style={item.style} hoverImage={item.hoverImage}>
                    <Image src={item.image} />
                    <S.GradeLabel className="grade-label">{item.name}</S.GradeLabel>
                  </S.GradeItem>
                )
              })
            }
          </S.GradeBox>

        </SS.ModalBody>
        {!hideFooter && <S.ModalFooter >
          <S.FooterText>We’ll curate the membership plans based on your child’s {i18n.t('grade')}</S.FooterText>
        </S.ModalFooter>
        }
      </SS.Modal>
    </SS.ModalOverlay>
  )
}

export default GradeSelectionModal;